"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormText = exports.StyledFormText = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
exports.StyledFormText = styled_components_1.default.small(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  margin-top: 4px;\n  ", ";\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  ", "\n"], ["\n  display: block;\n  margin-top: 4px;\n  ", ";\n  \n  ",
    "\n  \n  ",
    "\n  \n  ",
    "\n  ",
    "\n"])), style_utils_1.setTransition("color ease-in-out 0.15s"), function (props) {
    return props.color === "muted" && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), style_utils_1.colorSelector(props, "gray", 500));
}, function (props) {
    return props.inline && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: inline;\n      margin-top: 0;\n    "], ["\n      display: inline;\n      margin-top: 0;\n    "])));
}, function (props) {
    return props.invalid && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), style_utils_1.colorSelector(props, "danger", 500));
}, function (props) {
    return props.rtl && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      text-align: right;\n      direction: rtl;\n    "], ["\n      text-align: right;\n      direction: rtl;\n    "])));
});
var FormText = function (_a) {
    var id = _a.id, props = __rest(_a, ["id"]);
    return react_1.default.createElement(exports.StyledFormText, __assign({}, props, { id: id ? id + "-help" : "" }));
};
exports.FormText = FormText;
exports.FormText.defaultProps = {
    color: "muted"
};
exports.default = exports.FormText;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map